module.exports = __webpack_public_path__ + "static/media/footer.d2822da9.png";